import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@99designs/common/components/Icon';
import { Tooltip } from '@99designs/common/components/Tooltip';
import { DesignerLevel } from 'apps/find-designers/propTypes';
import LevelPill from 'components/Designers/LevelPill';
import WorkRelationshipDescriptions from 'apps/find-designers/components/Listing/WorkRelationshipDescriptions';

const DesignerBrandingExtras = ({ level, isContact, workRelationshipDescriptions }) => {
    function contactIcon() {
        if (!isContact) return null;

        return (
            <span className="designer-branding-extras__relationship">
                <Tooltip
                    tooltip={
                        <WorkRelationshipDescriptions
                            workRelationshipDescriptions={workRelationshipDescriptions}
                        />
                    }
                >
                    <Icon variations={['contacts-1']} />
                </Tooltip>
            </span>
        );
    }
    return (
        <div className="designer-branding-extras">
            <span className="designer-branding-extras__level">
                <LevelPill level={level} />
            </span>
            {contactIcon()}
        </div>
    );
};

DesignerBrandingExtras.propTypes = {
    level: DesignerLevel.isRequired,
    isContact: PropTypes.bool.isRequired,
    workRelationshipDescriptions: PropTypes.array.isRequired,
};

export default DesignerBrandingExtras;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerBrandingExtras.jsx